import React, { useEffect, useState, useCallback } from 'react';

const ResidentialVentures = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleCardHover = useCallback((index) => {
    setHoveredCard(index);
  }, []);

  // Inline styles with proper camelCase and all animations defined
  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)',
      color: 'white',
      padding: '80px 0',
      position: 'relative',
      overflow: 'hidden',
    },
    heroFloat: {
      position: 'absolute',
      top: '-50%',
      left: '-50%',
      width: '200%',
      height: '200%',
      background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
      // animation: 'float 6s ease-in-out infinite', // Removed invalid animation
    },
    heroContent: {
      // animation: 'fadeInUp 0.8s ease-out forwards', // Removed invalid animation
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
      transition: 'all 0.8s ease-out',
    },
    heroTitle: {
      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
      background: 'linear-gradient(135deg, white 0%, rgba(255,255,255,0.9) 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 700,
    },
    heroSubtitle: {
      fontSize: '1.5rem',
      opacity: 0.9,
      textShadow: '1px 1px 2px rgba(0,0,0,0.2)',
    },
    heroDivider: {
      width: '100px',
      height: '4px',
      background: 'linear-gradient(90deg, #FFBE1D, #FFA500)',
      margin: '2rem auto',
      borderRadius: '2px',
      boxShadow: '0 2px 10px rgba(255,190,29,0.5)',
    },
    sectionTitle: {
      background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 700,
      marginBottom: '3rem',
    },
    introCard: {
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '20px',
      padding: '2rem',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    },
    featureCard: (isHovered) => ({
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '20px',
      padding: '1.5rem',
      textAlign: 'center',
      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      boxShadow: isHovered ? '0 20px 40px rgba(33,128,206,0.3)' : '0 8px 32px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      overflow: 'hidden',
      transform: isHovered ? 'translateY(-10px) scale(1.02)' : 'translateY(0)',
    }),
    featureIcon: (isHovered) => ({
      background: 'linear-gradient(135deg, #FFBE1D 0%, #2180CE 100%)',
      borderRadius: '50%',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.5rem',
      margin: '0 auto 1rem',
      boxShadow: isHovered ? '0 12px 30px rgba(255,190,29,0.4)' : '0 8px 25px rgba(255,190,29,0.3)',
      transition: 'all 0.3s ease',
      transform: isHovered ? 'rotate(360deg) scale(1.1)' : 'rotate(0) scale(1)',
    }),
    amenitiesSection: {
      // animation: 'fadeInUp 0.8s ease-out forwards', // Removed invalid animation
      background: 'linear-gradient(135deg, rgba(248, 249, 250, 0.8) 0%, rgba(233, 236, 239, 0.8) 100%)',
      borderRadius: '25px',
      padding: '3rem',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    },
    amenityItem: (isHovered) => ({
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '15px',
      padding: '1.5rem',
      marginBottom: '1rem',
      transition: 'all 0.3s ease',
      boxShadow: isHovered ? '0 8px 25px rgba(40, 167, 69, 0.2)' : '0 4px 15px rgba(0, 0, 0, 0.05)',
      display: 'flex',
      alignItems: 'flex-start',
    }),
    amenityCheck: (isHovered) => ({
      background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontWeight: 'bold',
      marginRight: '1rem',
      boxShadow: isHovered ? '0 6px 20px rgba(40, 167, 69, 0.4)' : '0 4px 15px rgba(40, 167, 69, 0.3)',
      transition: 'all 0.3s ease',
      transform: isHovered ? 'scale(1.2)' : 'scale(1)',
    }),
    constructionCard: (isHovered) => ({
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '20px',
      padding: '2rem',
      textAlign: 'center',
      boxShadow: isHovered ? '0 20px 40px rgba(33,128,206,0.3)' : '0 8px 32px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
      transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
    }),
  };

  return (
    <>
      <div className="bg-white">
        {/* Hero Section */}
        <div style={styles.heroSection}>
          <div style={styles.heroFloat}></div>
          <div className="container position-relative">
            <div className="text-center" style={styles.heroContent}>
              <h1 className="display-3 font-weight-bold mb-3" style={styles.heroTitle}>
                Residential Ventures
              </h1>
              <p className="lead" style={styles.heroSubtitle}>
                Quality Homes for Every Family
              </p>
              <div style={styles.heroDivider}></div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="container py-5">
          {/* Introduction */}
          <section className="mb-5" style={{
            background: 'linear-gradient(135deg, rgba(248, 249, 250, 0.8) 0%, rgba(233, 236, 239, 0.8) 100%)',
            borderRadius: '25px',
            padding: '3rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
          }}>
            <h2 className="text-center" style={styles.sectionTitle}>Affordable Housing Solutions</h2>
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div style={styles.introCard}>
                  <p className="text-muted mb-4 lead" style={{ lineHeight: '1.8' }}>
                    Nakshatra Infra Projects develops residential ventures that focus on providing quality housing at reasonable prices. 
                    Our projects are designed with practical layouts, essential amenities, and proper legal approvals, making homeownership accessible to middle-class families.[web:9][web:12]
                  </p>
                  <p className="text-muted lead" style={{ lineHeight: '1.8' }}>
                    We believe everyone deserves a safe, comfortable home. Our residential projects are built with honest construction practices, transparent pricing, and customer-focused service.[web:11]
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Key Features */}
          <section className="mb-5" style={{
            background: 'linear-gradient(135deg, rgba(248, 249, 250, 0.8) 0%, rgba(233, 236, 239, 0.8) 100%)',
            borderRadius: '25px',
            padding: '3rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
          }}>
            <h2 className="text-center" style={styles.sectionTitle}>What We Offer</h2>
            <div className="row">
              {[
                { icon: '🏆', title: 'Legal Approvals', desc: 'HMDA and RERA approved projects with clear documentation and proper registrations.[web:14]' },
                { icon: '🏗️', title: 'Good Construction', desc: 'Quality materials and proper construction standards ensuring durability and safety.' },
                { icon: '📐', title: 'Practical Layouts', desc: 'Well-designed floor plans that maximize space and provide functional living areas.' },
                { icon: '🔒', title: 'Basic Security', desc: 'Gated communities with security personnel and controlled entry for resident safety.' },
                { icon: '📍', title: 'Good Locations', desc: 'Properties located near schools, hospitals, markets, and public transport connections.' },
                { icon: '💰', title: 'Loan Assistance', desc: 'Help with home loan processing through bank partnerships with reasonable interest rates.' }
              ].map((feature, index) => (
                <div key={index} className="col-md-6 col-lg-4 mb-4">
                  <div 
                    className="text-center p-4"
                    style={styles.featureCard(hoveredCard === index)}
                    onMouseEnter={() => handleCardHover(index)}
                    onMouseLeave={() => handleCardHover(null)}
                  >
                    <div className="mb-3" style={styles.featureIcon(hoveredCard === index)}>
                      {feature.icon}
                    </div>
                    <h3 className="h5 font-weight-bold text-dark mb-3">{feature.title}</h3>
                    <p className="text-muted">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Amenities */}
          <section className="mb-5" style={styles.amenitiesSection}>
            <h2 className="text-center mb-4" style={{...styles.sectionTitle, marginBottom: '3rem'}}>
              Basic Amenities Provided
            </h2>
            <div className="row">
              {[
                'Drinking Water Supply', 'Electricity', 'Drainage System', 'Roads & Pathways',
                'Parking Space', 'Common Areas', 'Security Gate', 'Power Backup'
              ].map((amenity, index) => (
                <div key={index} className="col-md-6 mb-3">
                  <div 
                    className="d-flex align-items-start"
                    style={styles.amenityItem(hoveredCard === `amenity-${index}`)}
                    onMouseEnter={() => handleCardHover(`amenity-${index}`)}
                    onMouseLeave={() => handleCardHover(null)}
                  >
                    <div style={styles.amenityCheck(hoveredCard === `amenity-${index}`)}>✓</div>
                    <div>
                      <h4 className="font-weight-bold text-dark mb-1">{amenity}</h4>
                      <p className="text-muted small mb-0">
                        {amenity === 'Drinking Water Supply' && '24/7 water supply through borewells and municipal connections'}
                        {amenity === 'Electricity' && 'Proper electrical connections with meters for each unit'}
                        {amenity === 'Drainage System' && 'Underground drainage for proper sewage management'}
                        {amenity === 'Roads & Pathways' && 'Paved internal roads with proper street lighting'}
                        {amenity === 'Parking Space' && 'Designated parking areas for residents and visitors'}
                        {amenity === 'Common Areas' && 'Small parks or open spaces for children and families'}
                        {amenity === 'Security Gate' && 'Main gate with security guard for controlled access'}
                        {amenity === 'Power Backup' && 'Generator backup for common areas and essential services'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Construction Standards */}
          <section className="mb-5" style={{
            // animation: 'fadeInUp 0.8s ease', // Removed invalid animation
            background: 'linear-gradient(135deg, rgba(248, 249, 250, 0.8) 0%, rgba(233, 236, 239, 0.8) 100%)',
            borderRadius: '25px',
            padding: '3rem',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
          }}>
            <h2 className="text-center mb-4" style={{
              background: 'linear-gradient(135deg, #2180CE 0%, #FFBE1D 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontWeight: 700,
              marginBottom: '3rem'
            }}>Construction Standards</h2>
            <div className="row">
              <div className="col-md-6 mb-4">
                <div 
                  className="construction-card p-4 text-center"
                  style={styles.constructionCard(hoveredCard === 'structure')}
                  onMouseEnter={() => handleCardHover('structure')}
                  onMouseLeave={() => handleCardHover(null)}
                >
                  <div className="feature-icon mb-3" style={styles.featureIcon(hoveredCard === 'structure')}>
                    🏢
                  </div>
                  <h3 className="h4 font-weight-bold text-dark mb-3">Structure</h3>
                  <ul className="list-unstyled text-muted">
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      RCC framed structure for strength and safety
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Quality cement and steel from known brands
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Proper foundation and column work
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Standard brick walls with plastering
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6 mb-4">
                <div 
                  className="construction-card p-4 text-center"
                  style={styles.constructionCard(hoveredCard === 'finishes')}
                  onMouseEnter={() => handleCardHover('finishes')}
                  onMouseLeave={() => handleCardHover(null)}
                >
                  <div className="feature-icon mb-3" style={styles.featureIcon(hoveredCard === 'finishes')}>
                    🛠️
                  </div>
                  <h3 className="h4 font-weight-bold text-dark mb-3">Finishes</h3>
                  <ul className="list-unstyled text-muted">
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Vitrified tiles in living areas
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Ceramic tiles in bathrooms and kitchen
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Painted walls with weather-resistant exterior
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span style={{ width: '20px', height: '20px', fontSize: '0.8rem', marginRight: '0.5rem' }}>✓</span>
                      Standard bathroom and kitchen fittings
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ResidentialVentures;
